import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { consigneesAPI, inventoryItemsAPI } from '../../services/api';
import Table from '../Common/Table';

const LowStockAlerts = () => {
  const [items, setItems] = useState([]);
  const [consignees, setConsignees] = useState([]);
  const [filterConsigneeId, setFilterConsigneeId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    consigneesAPI.getAll().then(setConsignees).catch(() => setConsignees([]));
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const data = await inventoryItemsAPI.getLowStock(
          filterConsigneeId ? { consignee_id: filterConsigneeId } : {}
        );
        if (cancelled) return;
        const raw = Array.isArray(data.items) ? data.items : [];
        setItems(
          raw.map((r) => ({
            ...r,
            alert_at_display:
              r.low_stock_threshold === -1
                ? '—'
                : r.low_stock_threshold == null
                  ? `${r.effective_low_stock_threshold} (default)`
                  : String(r.effective_low_stock_threshold),
          }))
        );
      } catch (e) {
        if (!cancelled) {
          alert('Error loading low stock: ' + e.message);
          setItems([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [filterConsigneeId]);

  const columns = [
    { key: 'inventory_items_id', label: 'ID' },
    { key: 'consignee_name', label: 'Consignee' },
    { key: 'hs_hts_number', label: 'HTS', format: (v) => v || '—' },
    { key: 'description', label: 'Description' },
    { key: 'quantity', label: 'Qty' },
    {
      key: 'alert_at_display',
      label: 'Alert at ≤',
    },
  ];

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Low stock alerts</h1>
        <Link to="/inventory-items" className="btn-secondary" style={{ textDecoration: 'none', display: 'inline-block' }}>
          Inventory items
        </Link>
      </div>

      <div className="form-row" style={{ marginBottom: 16 }}>
        <div className="form-group" style={{ maxWidth: 360 }}>
          <label>Filter by consignee</label>
          <select value={filterConsigneeId} onChange={(e) => setFilterConsigneeId(e.target.value)}>
            <option value="">All consignees</option>
            {consignees.map((c) => (
              <option key={c.id} value={c.id}>{c.company_name}</option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading…</div>
      ) : items.length === 0 ? (
        <div className="loading" style={{ color: '#2c7a4b' }}>
          No low-stock lines for this filter.
        </div>
      ) : (
        <>
          <p style={{ marginBottom: 8, fontWeight: 600 }}>
            {items.length} item{items.length === 1 ? '' : 's'} at or below threshold
          </p>
          <Table rowKey="inventory_items_id" data={items} columns={columns} />
        </>
      )}
    </div>
  );
};

export default LowStockAlerts;
